<tg-top-nav style="position: relative"></tg-top-nav>

<div style="background-color: #eeeeee">
  <div class="container">
    <div class="welcome-landing">
      <h1 class="mat-headline-4" style="margin-bottom: 20px" i18n="Home page|title @@homePage.title">Добро пожаловать в
        Telepost</h1>
      <div class="mat-body-1" style="max-width: 400px" i18n="Home page|title @@homePage.desc">
        Сервис отложенной публикации постов для Telegram.
        С его помощью вы с легкостью сможете запланировать выход постов на месяцы вперед.
      </div>
    </div>
  </div>
</div>

@if (channels$|async; as channels) {
  <div class="container" style="margin-top: 16px; min-height: calc(100vh - 350px)">
    <h3 class="mat-secondary" fxLayout="row" fxLayoutAlign="space-between center">
      <span i18n="Home page|text @@homePage.channelsCount">
      Ваши каналы@if (channels.count > 0) {
<span> - {{channels.count}}</span>
}
    </span>
    @if (channels?.count > 0) {
      <button id="addChannelBtn" mat-raised-button color="primary"
        (click)="openAddChannelForm()" i18n="Home page|button @@homePage.addChannelBtn">Подключить канал
    </button>
    }
  </h3>
  @if (channels.loading && !channels.loaded) {
    <tg-inline-loader></tg-inline-loader>
  } @else {
    @if (channels.count == 0) {
      <mat-card style="display: block; text-align: center; padding: 16px">
        <h3 i18n="Home page|text @@homePage.noChannels">
        У вас пока нет подключенных каналов.
      </h3>
        <button mat-raised-button color="primary" (click)="openAddChannelForm()"
          i18n="Home page|button @@homePage.addChannelBtn">Подключить канал
      </button>
      </mat-card>
    }
    @if (channels.count > 0) {
      <tg-channels-list [channels]="channels.items"></tg-channels-list>
    }
  }
</div>
}
<tg-footer></tg-footer>
